// ============================================================
// VCE — Adaptador de contenido (frontera de formatos)
// ============================================================
// ÚNICO lugar que conoce las formas legacy del consumidor
// (media[] tipado o images[] por extensión). Salida: VisualItem[].
// Conoce FORMATOS, nunca negocios. (P1/P7)
// ============================================================
import type { VisualItem, VisualItemType } from '../types';
import { isVideoUrl } from '../registries/mediaTypes';

interface RawMediaItem {
  type?: string;
  url: string;
  poster?: string;
}

/** Normaliza media[] tipado o images[] legacy → VisualItem[] */
export function normalizeVisualItems(
  media?: RawMediaItem[],
  images?: string[],
): VisualItem[] {
  if (media && media.length > 0) {
    return media.map((m, i) => {
      const type: VisualItemType = m.type === 'video' || isVideoUrl(m.url) ? 'video' : 'image';
      return { type, url: m.url, poster: m.poster, sort: i + 1 };
    });
  }
  if (images && images.length > 0) {
    return images.map((url, i) => ({
      type: isVideoUrl(url) ? 'video' : 'image',
      url,
      sort: i + 1,
    }));
  }
  return [];
}
